import * as Yup from 'yup';

export const certificateSchema = Yup.object().shape({
  certification_type: Yup.string().required('Certification Type is required'),
  issuing_body: Yup.string().required('Issuing Body is required'),
  expiration_date: Yup.string().required('Expiration Date is required'),
});
